<template>
  <ul class="container" >
    <li>
      <h2 class="title" >当前状态（{{ currentData.createTime }}）</h2>
      <ul class="data-ul" >
        <li>
          <p class="label">身高：</p>
          <p class="value">
            {{ currentData.height ? `${currentData.height}cm` : "" }}
            <template v-if="isTopBottom('height')" >
              <el-icon :class="isTopBottom('height')" />
            </template>
          </p>
        </li>
        <li>
          <p class="label">体重：</p>
          <p class="value">
            {{ currentData.weight ? `${currentData.weight}kg` : "" }}
            <template v-if="isTopBottom('weight')" >
              <el-icon :class="isTopBottom('weight')" />
            </template>
          </p>
        </li>
        <li>
          <p class="label">BMI：</p>
          <p class="value">
            {{ currentData.bmi }}
            <template v-if="isTopBottom('bmi')">
              <el-icon :class="isTopBottom('bmi')" />
            </template>
          </p>
        </li>
        <li>
          <p class="label">疾病状态：</p>
          <p class="value">{{ currentData.diseaseStatusSummary }}</p>
        </li>
        <li>
          <p class="label">体力劳动：</p>
          <p class="value">{{ physicalLaborName(currentData.physicalLabor) }}</p>
        </li>
        <li>
          <p class="label">中医证型：</p>
          <p class="value">{{ tcmDiagnosisName(currentData.tcmDiagnosis) }}</p>
        </li>
      </ul>
    </li>
    <li>
      <h2 class="title" >最初状态（{{ initialData.createTime }}）</h2>
      <ul class="data-ul" >
        <li>
          <p class="label">身高：</p>
          <p class="value">
            {{ initialData.height ? `${initialData.height}cm` : "" }}
          </p>
        </li>
        <li>
          <p class="label">体重：</p>
          <p class="value">
            {{ initialData.weight ? `${initialData.weight}kg` : "" }}
          </p>
        </li>
        <li>
          <p class="label">BMI：</p>
          <p class="value">
            {{ initialData.bmi }}
          </p>
        </li>
        <li>
          <p class="label">疾病状态：</p>
          <p class="value">{{ initialData.diseaseStatusSummary }}</p>
        </li>
        <li>
          <p class="label">体力劳动：</p>
          <p class="value">{{ physicalLaborName(initialData.physicalLabor) }}</p>
        </li>
        <li>
          <p class="label">中医证型：</p>
          <p class="value">{{ tcmDiagnosisName(initialData.tcmDiagnosis) }}</p>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ComparisonData",
  props: {
    patientOpenid: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      currentData: {},
      initialData: {},
      dietActivityLevel: [],
      dietSyndromeType: [],
    };
  },
  computed: {
    physicalLaborName() {
      return (e) => {
        const obj = (this.dietActivityLevel || []).find(item => item.dictKey === e) || {};
        return obj.dictValue || "";
      }
    },
    tcmDiagnosisName() {
      return (e) => {
        const obj = (this.dietSyndromeType || []).find(item => item.dictKey === e) || {};
        return obj.dictValue || "";
      }
    },
    isTopBottom() {
      return (e) => {
        let className = "";
        const current = this.currentData[e],
              initial = this.initialData[e];
        const count = current - initial;
        if (count > 0) {
          className = "el-icon-top";
        }else if (count < 0) {
          className = "el-icon-bottom";
        }
        return className;
      }
    }
  },
  created() {
    this.getDietActivityLevel();
    this.getDietSyndromeType();
    this.getData();
  },
  mounted() {

  },
  methods: {
    async getDietActivityLevel() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_activity_level"}`);
        if (!res) return false;
        const { data } = res;
        this.dietActivityLevel = data;
      }catch (e) {
        console.error(`体力劳动字典`, e);
      }
    },
    async getDietSyndromeType() {
      try {
        const res = await this.$get(`dictionary/type/${"diet_syndrome_type"}`);
        if (!res) return false;
        const { data } = res;
        this.dietSyndromeType = data;
      }catch (e) {
        console.error(`中医证型字典`, e)
      }
    },
    async getData() {
      try {
        const res = await this.$post("diet/patient/getIngredient", {
          patientOpenid: this.patientOpenid
        })
        if (!res) return false;
        const { data } = res;
        this.initialData = data[0];
        this.currentData = data[1];
      }catch (e) {
        console.log(`获取对照数据`, e);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  display: flex;
  padding: 20px 0;
  >li{
    width: 623px;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    .title{
      margin-bottom: 20px;
    }
    .data-ul{
      >li{
        display: flex;
        align-items: center;
        .label{
          width: 80px;
          height: 20px;
          color: #848484;
          text-align: right;
        }
        .value{
          height: 20px;
          line-height: 20px;
          color: #3D3D3D;
        }
      }
      >li + li{
        margin-top: 20px;
      }
    }
  }
  >li + li{
    margin-left: 20px;
  }
}
</style>
